import { Col, Select, SettingRow, Text } from "@rally/ui-kit";
import { useState } from "react";
import { LANGUAGE_CHOICES, type LanguageChoice } from "../localization/locale.ts";
import { useLocale } from "../localization/provider.tsx";
import { say } from "../localization/say.ts";

export function LanguageSetting() {
  const locale = useLocale();
  const [failed, setFailed] = useState(false);
  return (
    <Col testID="language-setting">
      <SettingRow
        title={say("language.title")}
        note={say("language.what")}
        control={
          <Select
            value={locale.preference}
            options={LANGUAGE_CHOICES.map((value) => ({
              value,
              label: say(`language.${value}` as "language.auto" | "language.en" | "language.fr"),
            }))}
            onChange={(value) => {
              setFailed(false);
              void locale.choose(value as LanguageChoice).catch(() => setFailed(true));
            }}
          />
        }
      />
      {failed ? (
        <Text typeName="caption" color="danger">
          {say("language.failed")}
        </Text>
      ) : null}
    </Col>
  );
}
